module.exports = __webpack_public_path__ + "img/stock7.da8e6a63.png";